import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RouteInfo } from "src/app/shared/sidebar/sidebar.metadata";
import { environment } from "src/environments/environment";
import { Order } from "../models/order_model";

@Injectable({
  providedIn: "root",
})
export class OpAdminOrdersService {
  constructor(private http: HttpClient) {}
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    return headers;
  }

  private sidebarnavItems: RouteInfo[] = [];
  myHeaders = this.setHeader();

  getAllOrder() {
    let url = environment.URL + "/order/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }

  orderRecordById(orderId) {
    let url = environment.URL + "/order/edit/" + orderId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  saveOrder(bodyParams: Order) {
    let url = environment.URL + "/order/create";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateOrder(bodyParams: Order) {
    let url = environment.URL + "/order/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  tableSearch(value, column, orderBy, pageId, siteId = null, jobId = null) {
    let url =
      environment.URL +
      "/order/" +
      value +
      "/" +
      column +
      "/" +
      orderBy +
      "?page=" +
      pageId;
      if (siteId != null && jobId != null) {
        url += "&site_id=" +
        siteId +
        "&job_id=" +
        jobId;
      }
    return this.http.get(url, { headers: this.myHeaders });
  }
  getCodeList(moduleName) {
    let url = environment.URL + "/code/" + moduleName;
    return this.http.get(url, { headers: this.myHeaders });
  }
  getAllManagerOrder() {
    let url = environment.URL + "/order/bySite";
    return this.http.get(url, { headers: this.myHeaders });
  }
  orderPrint(id) {
    let url = environment.URL + "/order/print/" + id;
    return this.http.get(url, { headers: this.myHeaders });
  }
  orderInvoiceDownloadFTP(id) {
    let url = environment.URL + "/order/invoice/download/ftp/" + id;
    return this.http.get(url, { headers: this.myHeaders });
  }
  informationMail(id) {
    let url = environment.URL + "/order/sendInformation/" + id;
    return this.http.get(url, { headers: this.myHeaders });
  }
  cancelOrder(id) {
    let url = environment.URL + "/order/cancel/" + id;
    return this.http.get(url, { headers: this.myHeaders });
  }
  editOrderOnCustomerRequest(orderId) {
    let url = environment.URL + "/cartInfo/orderItem/" + orderId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  cancelEditOrderOnCustomerRequest(cartItemsIds) {
    let url = environment.URL + "/cartInfo/cancel/" + cartItemsIds;
    return this.http.get(url, { headers: this.myHeaders });
  }
  progresStatus(orderid) {
    let url = environment.URL + "/order/isInProgress/true/" + orderid;
    return this.http.get(url, { headers: this.myHeaders });
  }
  // getAllProofcardForAccess(number, orderId) {
  //   let url = environment.URL + "/proofcardList/" + number + "/" + orderId;
  //   return this.http.get(url, { headers: this.myHeaders });
  // }

  getAllProofcardForAccess(value, column, pageId) {
    let url =
      environment.URL +
      "/proofcardList/" +
      value +
      "/" +
      column +
      "?page=" +
      pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  updateStatus(id, status) {
    let url = environment.URL + "/order/itemUpdateStatus/" + id + "/" + status;
    return this.http.get(url, { headers: this.myHeaders });
  }

  updateEmail(id, email) {
    let url = environment.URL + "/updateEmail/" + id + "/" + email;
    return this.http.get(url, { headers: this.myHeaders });
  }

  updateContactNumber(id, phonenumber) {
    let url =
      environment.URL + "/updateContactNumber/" + id + "/" + phonenumber;
    return this.http.get(url, { headers: this.myHeaders });
  }

  updateCustomerEmail(id, email) {
    let url = environment.URL + "/updateCustomerEmail/" + id + "/" + email;
    return this.http.get(url, { headers: this.myHeaders });
  }

  updateAddress(data) {
    let url = environment.URL + "/updateAddress";
    return this.http.post(url, data, { headers: this.myHeaders });
  }

  updateShippingAddress(data) {
    let url = environment.URL + "/updateShippingAddress";
    return this.http.post(url, data, { headers: this.myHeaders });
  }

  convertToPostalOrder(data) {
    let url = environment.URL + "/order/convertToPostalOrder/" + data.id;
    return this.http.post(url, data, { headers: this.myHeaders });
  }

  convertToSiteOrder(data) {
    let url = environment.URL + "/order/convertToSiteOrder/" + data;
    return this.http.post(url, data, { headers: this.myHeaders });
  }

  updateAdminComment(data) {
    let url = environment.URL + "/updateAdminComment";
    return this.http.post(url, data, { headers: this.myHeaders });
  }

  collectDeadlineData(data: any, type = 'all') {
    let url = environment.URL + "/order/deadline-data/" + type;
    return this.http.post(url, data, { headers: this.myHeaders, responseType: 'blob', observe: 'events', reportProgress: true });
  }

  startCollect(data: any, type = 'all') {
    let url = environment.URL + "/order/deadline-collect-data-start/" + type;
    return this.http.post(url, data);
  }

  getProgress(id: string) {
    let url = environment.URL + "/order/deadline-collect-data-progress/";
    return this.http.get(url + id);
  }

  downloadZip(id: string) {
    let url = environment.URL + "/order/deadline-collect-data-download/";
    return this.http.get(url + id, {
      responseType: 'blob'
    });
  }

  sendLinkToDownload(data: any)
  {
    let url = environment.URL + "/order/send-link-to-download";
    return this.http.post(url, data);
  }

  collectDeadlinePendingData(data: any, type = 'all') {
    let url = environment.URL + "/order/deadline-pending-data/" + type;
    return this.http.post(url, data, { headers: this.myHeaders, responseType: 'blob' });
  }

  uploadMultiple(data: any) {
    let url = environment.URL + "/order/image-upload-aws";

    return this.http.post(url, data, {
      observe: 'events',
      reportProgress: true
    });
  }

  exportOrder(
    exportOption,
    orderIds,
    isAllSelected,
    isSendMailSelected,
    orderBy,
    filter
  ) {
    let body = {
      export_option: exportOption,
      orderIds: orderIds,
      isAllSelected: isAllSelected,
      isSendMailSelected: isSendMailSelected,
      orderBy: orderBy,
      filter: filter
    };

    let url = environment.URL + "/order/export";
    return this.http.post(url, body, {
      headers: this.myHeaders,
      responseType: "arraybuffer",
      reportProgress: true,
    });
  }

  exportSiteOrder(
    exportOption,
    orderIds,
    isAllSelected,
    siteName,
    isSendMailSelected,
    orderType
  ) {
    let body = {
      export_option: exportOption,
      orderIds: orderIds,
      isAllSelected: isAllSelected,
      siteName: siteName,
      isSendMailSelected: isSendMailSelected,
      orderType: orderType,
    };

    let url = environment.URL + "/siteOrder/export";
    return this.http.post(url, body, {
      headers: this.myHeaders,
      responseType: "arraybuffer",
      reportProgress: true,
    });
  }
}
